module.exports = __webpack_public_path__ + "files/75e0e588f32f5aea1ef6ccd3b9fb16a0.png";